import { render } from "./OWidgetMini.vue?vue&type=template&id=5b3f7702"
import script from "./OWidgetMini.vue?vue&type=script&lang=js"
export * from "./OWidgetMini.vue?vue&type=script&lang=js"

import "./OWidgetMini.vue?vue&type=style&index=0&id=5b3f7702&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__